import { NavLink, Outlet, useLocation } from "react-router-dom";
import {
  LayoutDashboard,
  Users,
  Send,
  Settings as SettingsIcon,
  Inbox,
  Bot,
  LogOut,
} from "lucide-react";
import { useAuth } from "@/lib/auth";

const navItems = [
  { to: "/dashboard", label: "Dashboard", icon: LayoutDashboard, testid: "nav-dashboard" },
  { to: "/agent-campaigns", label: "AI Campaigns", icon: Bot, testid: "nav-agent-campaigns" },
  { to: "/campaigns", label: "Campaigns", icon: Send, testid: "nav-campaigns" },
  { to: "/lists", label: "Audience Lists", icon: Users, testid: "nav-lists" },
  { to: "/settings", label: "Settings", icon: SettingsIcon, testid: "nav-settings" },
];

export default function Layout() {
  const location = useLocation();
  const { user, logout } = useAuth();
  return (
    <div className="min-h-screen bg-[#F8FAFC] flex">
      {/* Sidebar */}
      <aside
        data-testid="sidebar"
        className="w-64 fixed left-0 top-0 h-screen border-r border-[#E2E8F0] bg-white flex flex-col justify-between"
      >
        <div>
          <div className="px-6 pt-7 pb-6 flex items-center gap-3">
            <div className="w-9 h-9 rounded-md bg-[#002FA7] flex items-center justify-center">
              <Inbox size={18} className="text-white" strokeWidth={2.5} />
            </div>
            <div>
              <div className="font-semibold text-[15px] tracking-tight text-[#0F172A]" style={{ fontFamily: "Outfit" }}>
                Inbox Marketing
              </div>
              <div className="text-[11px] text-[#94A3B8] font-medium uppercase tracking-wider">
                Bulk Email Suite
              </div>
            </div>
          </div>

          <div className="px-3">
            <div className="section-label px-3 pb-2 pt-2">Workspace</div>
            <nav className="flex flex-col gap-1">
              {navItems.map((item) => {
                const Icon = item.icon;
                const isActive =
                  location.pathname === item.to ||
                  (item.to !== "/dashboard" && location.pathname.startsWith(item.to));
                return (
                  <NavLink
                    key={item.to}
                    to={item.to}
                    data-testid={item.testid}
                    className={`nav-link ${isActive ? "active" : ""}`}
                  >
                    <Icon size={16} strokeWidth={2} />
                    <span>{item.label}</span>
                    <span className="ml-auto nav-dot" />
                  </NavLink>
                );
              })}
            </nav>
          </div>
        </div>

        <div className="px-6 pb-6 space-y-3">
          <div className="rounded-lg border border-[#E2E8F0] p-4 bg-[#F8FAFC]">
            <div className="text-[11px] font-semibold uppercase tracking-wider text-[#64748B]">
              Deliverability
            </div>
            <div className="text-sm text-[#0F172A] font-medium mt-1">Inbox-First Sending</div>
            <div className="text-xs text-[#475569] mt-1 leading-relaxed">
              Powered by Resend. Verify your domain to maximize inbox placement.
            </div>
          </div>

          {user && user.email && (
            <div className="flex items-center gap-2 pt-1" data-testid="user-menu">
              <div className="w-8 h-8 rounded-full bg-[#E5E9F6] text-[#002FA7] text-xs font-semibold flex items-center justify-center uppercase">
                {user.email.charAt(0)}
              </div>
              <div className="flex-1 min-w-0">
                <div className="text-xs text-[#0F172A] font-medium truncate" title={user.email}>
                  {user.email}
                </div>
                <button
                  onClick={logout}
                  className="text-[11px] text-[#475569] hover:text-[#E11D48] inline-flex items-center gap-1"
                  data-testid="btn-logout"
                >
                  <LogOut size={10} /> Sign out
                </button>
              </div>
            </div>
          )}
        </div>
      </aside>

      <main className="ml-64 flex-1 min-h-screen">
        <Outlet />
      </main>
    </div>
  );
}
